// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"345":"067a16fa","456":"37155fb8","656":"b99f7248","756":"8fc2bb08","787":"069db09e","968":"50fb18f9"}[chunkId] + ".chunk.js";
};